import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { FaxClient } from '../../api/server';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import * as signalR from '@microsoft/signalr';
import dayjs from 'dayjs';
import DateSelector from '../DateSelector/DateSelector';
import { ExtendedClient } from '../../api/ExtendedClient';

function FaxHistory() {
    const globalInfo = useSelector((state) => state.globalInfo)
    const [faxes, setFaxes] = React.useState([]);

    const [totalPageCount, setTotalPageCount] = React.useState(0);


    useEffect(() => {
        const newConnection = new signalR.HubConnectionBuilder()
            .withUrl(process.env.REACT_APP_API_URL + "/messagingHub", {
                transport: signalR.HttpTransportType.WebSockets | signalR.HttpTransportType.ServerSentEvents | signalR.HttpTransportType.LongPolling,
                withCredentials: true
            })
            .build();

        newConnection
            .start()
            .then(() => {
                console.log('Connected to SignalR Hub');
                newConnection.on('ReceiveMessage', (message) => {
                    reload();
                    //setMessages((prevMessages) => [...prevMessages, message]);
                });
            })
            .catch((err) => console.error('Error establishing connection:', err));

        return () => {
            if (newConnection) newConnection.stop();
        };
    // eslint-disable-next-line
    }, []);


    function reload() {

        const client = (new ExtendedClient(FaxClient)).getClient();

        client.getFaxesByDate(globalInfo.currentCompanyId, startDate, endDate).then((data) => {
            setFaxes(data)

            var count = 0;
            data.forEach(x => {
                if (x.numberOfPages) {
                    count = count + x.numberOfPages
                }
            })
            setTotalPageCount(count);
        })
    }

    React.useEffect(() => {
            reload();
        // eslint-disable-next-line
    }, [])


    function getNumberOfPages(numberOfPages) {
        if (numberOfPages) {
            if (numberOfPages > 0) {
                return <>{numberOfPages}</>
            }
        }
        return <>-</>
    }

    const date = new Date()
    const y = date.getFullYear()
    const m = date.getMonth();

    const [startDate, setStartDate] = useState(dayjs(new Date(y, m, 1)));
    const [endDate, setEndDate] = useState(dayjs(new Date(y, m + 1, 0)));

    useEffect(() => {
        reload()
        // eslint-disable-next-line
    }, [startDate, endDate])

    return (
        <div><h1> Fax History</h1>
            <DateSelector selectedStartDate={startDate} selectedEndDate={endDate} setSelectedStartDate={setStartDate} setSelectedEndDate={setEndDate} ></DateSelector>
            <h2>Total # Of Pages Sent: {totalPageCount}</h2>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell><strong>Date/Time</strong></TableCell>
                            <TableCell><strong>From Number</strong></TableCell>
                            <TableCell><strong>To Number</strong></TableCell>
                            <TableCell width={300}><strong>Status</strong></TableCell>
                            <TableCell width={400}><strong>Details</strong></TableCell>
                            <TableCell width={100}><strong>Page Count</strong></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            faxes.map((item, index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableCell>
                                            {
                                                item.createDateTime && <>
                                                    {(new Date(item.createDateTime)).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} &nbsp;
                                                    {(new Date(item.createDateTime)).toLocaleTimeString()}
                                                </>
                                            }
                                        </TableCell>
                                        <TableCell>
                                            {item.fromNumber.getFormattedPhoneNum()}
                                        </TableCell>
                                        <TableCell>
                                            {item.toNumber.getFormattedPhoneNum()}
                                        </TableCell>
                                        <TableCell>
                                            <a target='_blank'  rel="noreferrer" href={process.env.REACT_APP_API_URL + '/fax/status/' + item.faxId}>
                                                {item.status}
                                            </a>
                                        </TableCell>
                                        <TableCell>
                                            {item.statusMessage}
                                        </TableCell>
                                        <TableCell>
                                            {
                                                getNumberOfPages(item.numberOfPages)
                                            }
                                        </TableCell>
                                    </TableRow>
                                )
                            })
                        }

                    </TableBody>
                </Table>
            </TableContainer>

        </div>
    )
}

export default FaxHistory